export default "__VITE_ASSET__DKusbzvZ__"